export default __webpack_public_path__ + "static/circle-3d472e4911c3b53ceced8f95056f3715.svg";